/**
 * Created by Pavel Kozhin on 18/04/16.
 */

define([
      'library/fcse-compatibility/object',
      'library/fcse-component/optionsMixin'
    ],
    function(Object, OptionsMixin) {
      /**
       * Shows the details for the map place
       * @param element
       * @param options
       * @constructor
       */
      var DetailOverlay = function(element, options) {
        this.element = element;
        this._elementNode = element.get(0);

        var defaultOptions = {
          contentSelector: '[data-fcse-role="map-modal-detail-overlay-content"]',
          closeBtnSelector: '[data-fcse-role="map-overlay-closebtn"]'
        };

        this.addOptions(defaultOptions, options);
        this._init();
      };

      DetailOverlay.prototype = $.extend(Object.create(OptionsMixin), {
        /**
         * Initializer
         * @private
         */
        _init: function() {
          var self = this;
          this._contentElement = $(this.option('contentSelector'), this.element);

          $(this.option('closeBtnSelector')).click(function() {
            self.close();
          });
        },

        /**
         * Opens overlay
         */
        open: function() {
          if (this._elementNode.style.display !== 'block') {
            this._elementNode.style.display = 'block';
          }
        },

        /**
         * Closes overaly
         */
        close: function() {
          if (this._elementNode.style.display === 'block') {
            this._elementNode.style.display = 'none';
          }
        },

        /**
         * Sets html content
         * @param {string|null} html
         */
        setContent: function(html) {
          if (!html) {
            this.element.addClass('is-loading');
            this._contentElement.html('');
          } else {
            this.element.removeClass('is-loading');
            this._contentElement.html(html);
          }
        }
      });

      return DetailOverlay;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/map/detailOverlay.js